import { React } from "react";
import { useTranslation } from "react-i18next";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { ValidateFields } from "../ValidateFields";
import RecommendedName from "../components/RecommendedName";
import RecommendedEmail from "../components/RecommendedEmail";
import DetailsNotes from "../components/DetailsNotes";
import AssignTo from "../components/AssignTo";
import ApplicationDate from "../components/ApplicationDate";
import CandidateSource from "../components/CandidateSource";
import CapturedByMe from "../components/CapturedByMe";
import { Row } from "react-bootstrap";

export function ApplicationDetails({ changeCardStatus, cardStatus }) {
  const { t } = useTranslation();
  const { searchObject, setSearchObject, onChange } = useAdvanceSearchContext();

  function clearApplicationDetails() {
    searchObject.recommendedName = undefined;
    searchObject.recommendedEmail = undefined;
    searchObject.detailsNotes = undefined;
    searchObject.assignToId = undefined;
    searchObject.ApplicationDateStart = undefined;
    searchObject.ApplicationDateEnd = undefined;
    searchObject.candidateSourceId = undefined;
    searchObject.IsCapturedByMeId = undefined;

    setSearchObject({
      ...searchObject
    });
  }

  return (
    <>
      <div className="accordion-item border-accordion">
        <h2
          className="accordion-header margin-accordion"
          id="headingCompetence"
        >
          <button
            className={`accordion-button border-accordion-button ${
              cardStatus ? "" : "collapsed heding-bold"
            }`}
            type="button"
            data-bs-target="#collapseCvs"
            aria-expanded="true"
            aria-controls="collapseCvs"
            onClick={changeCardStatus}
            id="accordionEducation"
          >
            {`${t("Application Details")} ${ValidateFields.applicationDetails(
              searchObject
            )}`}
          </button>
        </h2>
        <div
          id="accordionInputs"
          className={`accordion-collapse ${cardStatus ? "" : "collapse"}`}
          aria-labelledby="headingCompetence"
          data-bs-parent="#accordionFlushDocuments"
        >
          <div className="accordion-body table-wrap ">
            <Row>
              <div className="col-md-4">
                <AssignTo
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <ApplicationDate
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <CandidateSource
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <CapturedByMe
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <RecommendedName
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <RecommendedEmail
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-8">
                <DetailsNotes
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
          </div>
          <div className="text-end button-clear-position">
            <button
              className="app-button btn-second btn-md"
              onClick={clearApplicationDetails}
            >
              {t("Clear Application Details")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
